$( document ).ready(function() {

	const $width = window.innerWidth || document.body.clientWidth;
	var $prevScrollpos = window.pageYOffset;
	window.onscroll = function() {
		if (!$(".hamburger").hasClass("is-active")) {
			var $currentScrollPos = window.pageYOffset;
			if ($width <= 575 ) {
				if ($prevScrollpos > $currentScrollPos) {
					$("#hide-scroll").css("top", 0);
				} else if($currentScrollPos > 1) {
					$("#hide-scroll").css("top", "0px");
				}
			}
			$prevScrollpos = $currentScrollPos;
		}
	}


	const $hamburger = $(".hamburger");
	$hamburger.on("click", function() {
		$hamburger.toggleClass("is-active");
		$("html,body").toggleClass("overflow-hidden");
		setTimeout(function() {
			$(".scroll").toggleClass("overflow-auto");
		}, 450);
	});

	// mobile
	jQuery('header').on('click', 'a.mobile-trigger-icon', function() {
		jQuery(this).next().toggle();
		return false;
	});

	$(".navigation .navbar-nav .dropdown").each(function( index ) {
		const $dropdownSelector = $(this).children(".dropdown-menu");
		const $colSelector = $(this).children(".col-menu");

		if($dropdownSelector.length > 0) {
			const $menuItemSelector = $(this).children(".menu-item");
			const $paddingMenuItem = parseInt($menuItemSelector.css("padding-left"));
			const $menuItemWidth = $menuItemSelector.width() + ($paddingMenuItem * 2);

			$dropdownSelector.css("left", 0);
			const $originPadding = parseInt($dropdownSelector.css("padding-left"));
			const $originWidth = $dropdownSelector.width() + ($originPadding * 2);
			$dropdownSelector.css("left", "");

			const $changedWidth = $dropdownSelector.width() + ($originPadding * 2);

			const $diffWidth = $originWidth - $changedWidth;

			if ($diffWidth <= (($originWidth / 2) - $menuItemWidth / 2)) {
				var $Selector = $diffWidth !== 0 ? $dropdownSelector : $colSelector;
				$Selector.css("margin-left", -(($originWidth / 2) - $menuItemWidth / 2) + "px")
			} else {
				$dropdownSelector.css("right", 0);
			}
		}
	});


	$(".mobile-menu").find(".show-mobile").css("display", "block");
	let $isHovered = false;
	$( ".dropdown" ).hover(
		function() {
			$isHovered = true;
			var $thisDropdown = $(this);
			$(".dropdown-menu").each( function () {
				if ($thisDropdown.find(".dropdown-menu")[0] !== this) {
					$(this).fadeOut("fast");
				}
			});

			$(".nav-pointer").fadeOut("fast");
			$( this ).find(".dropdown-menu").fadeIn("fast");
			$( this ).find(".nav-pointer").fadeIn("fast");
		}, function() {
			$isHovered = false;
			const $dropdown = $(this).find(".dropdown-menu");
			const $navPointer = $(this).find(".nav-pointer");
			setTimeout(function() {
				if (!$isHovered) {
					$dropdown.fadeOut("fast");
					$navPointer.fadeOut("fast");
				}
			}, 1000);
		}
	);
});